angular.module('rightPaneModule')
    .directive('dblActivity', ['$compile', '$log', 'compareDay', 'navigation', 'dblLessonService',
        function($compile, $log, dblCompareDay, dblNavigation, dblLessonService) {

          var LESSON_DIRECTIVE_HTML =
            '<dbl-lesson-activity dbl-activity="dblActivity" ' +
            'dbl-show-student-name="dblShowStudentName" dbl-use-ux-ease-of-use="dblUseUxEaseOfUse"></dbl-lesson-activity>';

          var LESSON_GROUP_DIRECTIVE_HTML =
            '<dbl-lesson-group-activity dbl-activity="dblActivity" ' +
            'dbl-show-student-name="dblShowStudentName" dbl-use-ux-ease-of-use="dblUseUxEaseOfUse"></dbl-lesson-group-activity>';

          var LESSON_STANDARD_DIRECTIVE_HTML =
            '<dbl-standard-activity dbl-activity="dblActivity" ' +
            'dbl-show-student-name="dblShowStudentName" dbl-use-ux-ease-of-use="dblUseUxEaseOfUse"></dbl-standard-activity>';

        // This determines which activity card directive is used based on the type of activity.
        // This probably could have been done purely in an html template with ng-switch, but was concerned
        // that might be less performant both in terms of memory and rendering time.
        // ng-include could also have been an option, but it doesn't exist in Angular 2, so didn't
        // seriously condiser it (https://github.com/angular/angular/issues/2753).
        var replaceCardDirective = function (activity, scope, element) {
            var html;
            if (activity.isLessonGroupActivity()) {
                html = LESSON_GROUP_DIRECTIVE_HTML;
            } else if (activity.isStandardCompleteActivity()) {
                html = LESSON_STANDARD_DIRECTIVE_HTML;
            } else {
                html = LESSON_DIRECTIVE_HTML;
            }

            var activityEle = $compile(html)(scope);

            element
                .find('.dbl-activity-card-core')
                .empty()
                .append(activityEle);
        };

        return {
            restrict: 'E',
            templateUrl: '/resources/right-pane/components/activity-feed/dbl-activity.directive.html',
            scope: {
                dblActivity: '=',
                dblShowStudentName: '=',
                dblUseUxEaseOfUse: '='
            },
            link: function(scope, element) {
                var _showDate;

                scope.$watch('dblActivity', function (newVal) {
                    if (newVal) {
                        replaceCardDirective(newVal, scope, element);
                    }
                });

                // TODO: consider moving the date display out to the feed directive
                scope.showDate = function () {
                    if (_showDate === undefined) {
                        _showDate = dblCompareDay.isDifferentDay(scope.dblActivity.timestamp);
                    }
                    return _showDate;
                };

            }
        };
    }]);
